<template>
    <v-row no-gutters>
        <template v-for="(charge, index) in charges">
            <v-col lg="4" md="3" sm="6" :key="index">
                <screen-charge :charge="charge" mode="print"></screen-charge>
            </v-col>
        </template>
    </v-row>
</template>
<script>
import WithCrimeRecords from "@components/screen/mixins/WithCrimeRecords";
export default {
    name: "applicant-crimes",
    components: {
        ScreenCharge: () =>
            import("@components/screen/components/Search/ScreenCharge"),
    },
    mixins: [WithCrimeRecords],
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {
        this.records = this.items.filter(
            (item) => this.$_.get(item, "disposition", "") !== "DISMISSED"
        );
    },
    mounted() {},
    updated() {},
    detroyed() {},
    methods: {},
};
</script>

<style scoped>
</style>